"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useAppContext } from "@/contexts/app";

const Analytics = dynamic(() => import("@/components/analytics"), {
  ssr: false,
});

const Adsense = dynamic(() => import("./adsense"), {
  ssr: false,
});

const GlobalToaster = dynamic(() => import("./global-toaster"), {
  ssr: false,
});

const SignModalPortal = dynamic(() => import("@/components/sign/modal-portal"), {
  ssr: false,
});

const GLOBAL_SERVICES_DELAY_MS = 60_000;

export default function GlobalClientServices() {
  const { showSignModal } = useAppContext();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (showSignModal) {
      setIsReady(true);
      return;
    }

    let timeoutId: number | null = null;

    const enableServices = () => {
      setIsReady(true);
    };

    const schedule = () => {
      timeoutId = window.setTimeout(enableServices, GLOBAL_SERVICES_DELAY_MS);
    };

    const handleInteraction = () => {
      enableServices();
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }

    window.addEventListener("pointerdown", handleInteraction, {
      once: true,
      passive: true,
    });
    window.addEventListener("keydown", handleInteraction, { once: true });

    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
      window.removeEventListener("load", schedule);
      window.removeEventListener("pointerdown", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };
  }, [showSignModal]);

  if (!isReady) {
    return null;
  }

  return (
    <>
      <GlobalToaster />
      <Analytics />
      <Adsense />
      <SignModalPortal />
    </>
  );
}
